import { render, staticRenderFns } from "./MessageTemplatesIndexComponent.vue?vue&type=template&id=294c16b7&scoped=true"
import script from "./MessageTemplatesIndexComponent.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c16b7",
  null
  
)

export default component.exports